import { Collapse, IconButton, makeStyles } from "@material-ui/core";
import { CancelOutlined } from "@mui/icons-material";
import React, { useEffect } from "react";
const useStyles = makeStyles((theme) => ({
  container: {
    width: "100%",
    height: "120px",
    backgroundColor: "#e41300",
    marginTop: "65px",
    display: "flex",
    alignItems: "center",
  },
  errorDisc: {
    width: "95%",
    marginLeft: "auto",
    marginRight: "auto",
  },
  headingRow: {
    display: "flex",
    justifyContent: "space-between",
  },
  heading: {
    display: "flex",
    alignItems: "center",
    color: "#fff",
  },
  white: {
    color: "#fff",
  },
  errormsg: {
    color: "white",
    marginTop: 0,
    marginLeft: "6px",
  },
}));
function CustomErrorBoundary({ error, setError, message }) {
  const classes = useStyles();

  const handleClose = () => {
    setError({ ...error, status: false });
  };

  useEffect(() => {
    if (error?.status) {
      // Set a timer to close the error after 5000 milliseconds (adjust as needed)
      const timerId = setTimeout(() => {
        handleClose();
      }, 5000);

      // Clean up the timer when the component unmounts or when the error changes
      return () => clearTimeout(timerId);
    }
  }, [error, handleClose]);

  return (
    <Collapse in={error} unmountOnExit>
      {error?.status && (
        <div className={classes.container}>
          <div className={classes.errorDisc}>
            <div className={classes.headingRow}>
              <div style={{ display: "flex" }}>
                <IconButton size="small" onClick={handleClose}>
                  <CancelOutlined className={classes.white} />
                </IconButton>
                <h2 className={classes.white}>Access Denied </h2>
              </div>
            </div>
            <p className={classes.errormsg}>{error.message}</p>
          </div>
        </div>
      )}
    </Collapse>
  );
}

export default CustomErrorBoundary;
